import { Route } from 'src/routes/Route'

export const PricingRoute = Route({ path: '/pricing' })
export type PricingRoute = Route<typeof PricingRoute>
